import Mobile from "./card-green-mobile";
import Desktop from "./card-green-desktop";

const green = {
    Mobile,
    Desktop
}

export default green;